import React from 'react'
import Media from 'react-media'
import { desktopAssets } from 'src/containers/PreCache'
import { SIZES } from 'src/styles/theme'
import styled from 'styled-components'

export default function Layout({ children }) {
  return (
    <Media query={`(max-width: ${SIZES.mobileBreakpoint})`}>
      {(matches) => (matches ? <BackgroundWrapperMobile>{children}</BackgroundWrapperMobile> : <BackgroundWrapper>{children}</BackgroundWrapper>)}
    </Media>
  )
}

const BackgroundWrapper = styled.div`
  min-height: 100dvh;
  background-image: url(${desktopAssets.landingBg});
  background-size: cover;
  background-position: center;

  .closedText {
    font-size: 1.5rem;
    font-weight: bold;
    text-align: center;
    margin: 20px 0;
  }

  .wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .content-wrapper {
    background: #fff;
    padding: 56px;
    padding-bottom: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .min-w-400px {
      min-width: 400px;
    }
  }

  .form {
    margin-bottom: 30px;
  }

  .header-logo {
    max-width: 961px;
    width: 100%;
    height: auto;
  }

  .hint {
    max-width: 602px;
    background: #f8f8f8;
    padding: 24px 26px;
    font-size: 14px;
    color: #434343;
    line-height: normal;
    text-align: center;
    margin-bottom: 30px;
  }

  .btn {
    padding: 20px 100px;
    background: #052e68;
    font-size: 1rem;
    line-height: normal;
  }

  h1 {
    font-size: 1.75rem;
    line-height: 1.875rem;
    font-weight: bold;
    text-align: center;
  }

  .muted {
    color: #999999;
    font-size: 16px;
    text-align: center;
  }

  label {
    color: #434343;
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.375rem; /* 137.5% */
  }

  .thank-you {
    text-align: center;
  }
`

// Mobile Style
const BackgroundWrapperMobile = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100dvh;
  background: #fff;

  .closedText {
    font-size: 1.5rem;
    font-weight: bold;
    text-align: center;
    margin: 20px 0;
  }

  .content-wrapper {
    padding: 16px;
    flex: 1;

    h1 {
      font-size: 24px;
      font-weight: bold;
      line-height: 30px;
      text-align: center;
      margin-bottom: 40px;
    }

    .muted {
      color: #999999;
      font-size: 16px;
      text-align: center;
    }

    .form {
      margin-bottom: 40px;
    }

    .input-mobile-fix {
      width: 100%;

      @media (min-width: ${SIZES.mobileBreakpoint}) {
        width: auto;
      }
    }

    .hint {
      background: #f8f8f8;
      padding: 24px 26px;
      font-size: 14px;
      color: #434343;
      line-height: normal;
      text-align: center;
      margin-bottom: 50px;
    }

    .btn {
      padding: 20px 100px;
      background: #052e68;
      font-size: 1rem;
      line-height: normal;
    }

    .thank-you {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      h2 {
        font-size: 1.5rem;
        line-height: 2rem;
        text-align: center;
      }

      p {
        text-align: center;
        font-size: 0.875rem;
        font-weight: 400;
        line-height: 1.375rem;
      }
    }
  }
`
